import React, { Suspense, useMemo } from 'react'

import { WebfontLoader } from './WebfontLoader'

export interface FontLoadProps {
  children?: React.ReactNode
  fonts?: string[]
}

export function FontLoad({ children, fonts }: FontLoadProps) {
  // Stabilize the config by its font-list *content* (JSON handles the commas in
  // family strings like 'Roboto:300,300i'), so WebfontLoader only reloads when
  // the fonts actually change — not on every parent render.
  const familiesKey = JSON.stringify((fonts ?? []).filter((item) => item))
  const config = useMemo(() => ({ google: { families: JSON.parse(familiesKey) as string[] } }), [familiesKey])
  const hasFonts = config.google.families.length > 0

  return hasFonts ? (
    <Suspense fallback={null}>
      <WebfontLoader config={config}>{children}</WebfontLoader>
    </Suspense>
  ) : (
    <>{children}</>
  )
}
